module.exports = __webpack_public_path__ + "static/media/france.45c1c56c.svg";